import * as styles from './ContentRatingDisplay.css';

interface SimpleContentRatingProps {
  /** Simple fallback rating string (e.g., "E", "T", "M") */
  pgRating: string;
  /** Optional list of community genres */
  genres?: string[];
  /** Additional CSS class name */
  className?: string;
}

/**
 * SimpleContentRating
 *
 * Fallback display path when rich Microsoft Store rating data is not available.
 * Shows only the rating text (no badge per UX feedback) and optional genres with divider.
 *
 * Layout:
 *   RATING
 *   ---divider---
 *   Genre1, Genre2
 *
 * Accessibility:
 * - Rating exposed as plain uppercase text (semantic span)
 * - Divider is decorative (CSS only)
 */
export function SimpleContentRating({ pgRating, genres, className }: SimpleContentRatingProps) {
  return (
    <div className={className ? `${styles.container} ${className}` : styles.container}>
      <div className={styles.ratingRow}>
        <span className={styles.ratingText}>{pgRating}</span>
      </div>
      {genres && genres.length > 0 && (
        <>
          <div className={styles.divider} />
          <div className={styles.genresText}>{genres.join(', ')}</div>
        </>
      )}
    </div>
  );
}
